interface PlusIcon2Props {
  size?: number;
  color?: string;
}

const PlusIcon2 = ({ size = 24, color = 'currentColor' }: PlusIcon2Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
  >
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

export default PlusIcon2;
